class HeaderMenu extends HTMLElement {
    timingOptions = {
        duration: 300,
        easing: "linear",
    };
    constructor() {
        super();

        this.container = this.querySelector(".header__inline-menu > ul");
        this.itemsDetails = this.querySelectorAll("[data-items-menu] details");
        this.overlay = document.querySelector(".header-menu__overlay-element");
        this.dropdownInnerItemImages = this.querySelectorAll(
            ".dropdown-inner > [data-item-image-index]"
        );

        /* remove dropdown menu links if config option is checked */
        this.dropdownInnerItemImages ? this.removeDropdownMenuLinks() : null;

        const dropdownInner = this.querySelectorAll(
            ".dropdown-inner.full-width"
        );
        if (this.container && dropdownInner) this.setMaxHeight(dropdownInner);

        this.querySelectorAll("details-disclosure > details").forEach(
            (detail) => {
                if (this.container.dataset?.activateMenu == "on_click") {
                    // activate top level items on hover
                    detail.addEventListener(
                        "click",
                        this.activateTopLevelOnClick.bind(this)
                    );
                } else {
                    // activate top level items on hover - default behavior
                    detail.addEventListener(
                        "mousestop",
                        this.activateTopLevelOnHover.bind(this)
                    );
                    detail.addEventListener(
                        "mouseleave",
                        this.mouseLeave.bind(this)
                    );
                }

                // highlight top level items when its child active
                this.highlightParentItemOnActiveChild(detail);
            }
        );

        // megamenu - open dropdown inner always
        this.itemsDetails?.forEach((detail) => {
            if (detail.lastElementChild.dataset.typeMenu == "full-width")
                detail.setAttribute("open", true);
        });
    }

    connectedCallback() {
        // remove overlay on click/hover
        if (this.container.dataset?.activateMenu == "on_click")
            this.overlay.addEventListener(
                "click",
                this.removeOverlay.bind(this)
            );
        else
            this.overlay.addEventListener(
                "mouseover",
                this.removeOverlay.bind(this)
            );
    }

    updatePositionThirdLevelMenu(detail) {
        let dropdownInner = detail.children[1];
        if (!dropdownInner?.classList.contains("small")) return;

        let menuDisclosure = dropdownInner.querySelectorAll(
            ".childlist-menu--disclosure"
        );

        menuDisclosure.forEach((childlist) => {
            const elX = childlist.getBoundingClientRect().x;
            const elWidth = childlist.getBoundingClientRect().width;

            if (elX + elWidth > this.container.offsetWidth)
                childlist.setAttribute("data-menu-position", "updated");
        });
    }

    activateTopLevelOnClick(e) {
        let detail = e.target.closest("details"),
            summary = e.target.closest("summary"),
            topLevelItems = this.container.querySelectorAll(
                "details-disclosure > details > summary > a"
            );

        // remove active class from all items
        topLevelItems.forEach((item) => {
            item.classList.remove("list-menu__item--active");
        });

        // position of childlist-menu--disclosure list (third-level) to navigation width
        this.updatePositionThirdLevelMenu(detail);

        if (
            detail.parentElement.nodeName === "DETAILS-DISCLOSURE" &&
            e.target.nodeName !== "A"
        ) {
            e.preventDefault();
            e.stopPropagation();
            detail.setAttribute("open", true);
            this.showDropdownMenu(detail);

            /* show overlay only for Department item menu - small type */
            if (detail.parentElement.parentElement.dataset.mainItemMenu)
                this.showOverlay();

            // highlight the active menu item
            summary?.children[0].classList.add("list-menu__item--active");
        }
    }

    activateTopLevelOnHover(e) {
        let detail = e.target.closest("details");

        /* first item of small menu uses separate event */
        if (detail.parentElement.parentElement.dataset.mainItemMenu) {
            this.container.style.overflow = "visible";
            this.showOverlay();
        }

        // position of childlist-menu--disclosure list (third-level) to navigation width
        this.updatePositionThirdLevelMenu(detail);

        detail.setAttribute("open", true);
        this.showDropdownMenu(detail);

        // diactivate on Item leave
        if (detail.closest(".full-width") == null)
            detail.addEventListener("mouseleave", this.mouseLeave.bind(this));
    }

    showOverlay() {
        this.overlay.classList.add("shown");
    }

    removeOverlay() {
        this.overlay.classList.remove("shown");
    }

    getSubMenuHeight(submenu) {
        this.subMenuHeight =
            submenu.getBoundingClientRect().bottom -
            submenu.getBoundingClientRect().top;
        return this.subMenuHeight;
    }

    setMinHeight(detail) {
        let childListsMenu = detail.querySelectorAll(
            ".childlist-menu--disclosure"
        );

        /* set childlist height as submenu height */
        if (
            !childListsMenu.length ||
            !detail.parentElement.parentElement.dataset.mainItemMenu
        )
            return;

        childListsMenu.forEach((childList) => {
            childList.style.minHeight = this.subMenuHeight
                ? `${this.subMenuHeight}px`
                : `${this.getSubMenuHeight(detail.querySelector("ul"))}px`;
        });
    }

    mouseOver(detail) {
        detail.querySelectorAll("details").forEach((childDetail) => {
            /* show overlay only for main (first) small item menu */
            if (detail.parentElement.parentElement.dataset.mainItemMenu)
                this.showOverlay();

            childDetail.addEventListener("mouseover", (evt) => {
                this.mouseOver(childDetail);
            });
            childDetail.addEventListener(
                "mouseleave",
                this.mouseChildLeave.bind(this)
            );
        });

        detail.setAttribute("open", true);
        this.setMinHeight(detail);
    }

    mouseLeave(event) {
        let detail = event.target;

        this.subMenuHeight = false; // reset submenu height
        detail.setAttribute("closing", true);
        this.hideDropdownMenu(detail);

        setTimeout(() => {
            detail.removeAttribute("open");
        }, 200);
    }

    showDropdownMenu(detail) {
        if (!detail.closest("li").hasAttribute("item-index")) return;
        detail.removeAttribute("closing");

        const element = detail.children[1];
        if (!element) return;

        // megamenu dropdown overlay
        if (
            element.dataset.megamenuUseOverlay &&
            element.classList.contains("full-width")
        ) {
            this.showOverlay();
            this.overlay.style.top =
                element.getBoundingClientRect().bottom -
                element.clientHeight / 2 +
                "px";
        } else this.overlay.style.top = "0";

        if (
            !this.container.classList.contains("with--dropdown__menu-animation")
        )
            return;

        var animation = element.animate(
            { opacity: "0" },
            { overflow: "hidden" },
            this.timingOptions
        );

        animation.onfinish = () => {
            element.style.opacity = "1";
        };
    }

    hideDropdownMenu(detail) {
        if (!detail.closest("li").hasAttribute("item-index")) return;

        // megamenu dropdown remove overlay
        this.removeOverlay();

        const element = detail.children[1];

        if (
            !this.container.classList.contains("with--dropdown__menu-animation")
        )
            return;
        var animation = element.animate(
            { opacity: "1" },
            { overflow: "auto" },
            this.timingOptions
        );

        animation.onfinish = () => {
            element.style.opacity = "0";
        };
    }

    mouseChildLeave(event) {
        /* first item of small menu */
        this.subMenuHeight = false;
        if (event.target.hasAttribute("open")) {
            setTimeout(() => {
                event.target.removeAttribute("open");
            }, 200);
        }
    }

    removeDropdownMenuLinks() {
        const dropdownGrid = this.querySelectorAll(".container--grid");

        this.dropdownInnerItemImages.forEach((item) => {
            dropdownGrid?.forEach((dropdown) => {
                if (
                    dropdown.children[0].dataset.itemIndex ===
                    item.dataset.itemImageIndex
                )
                    dropdown.children[0].remove();
            });
        });
    }

    setMaxHeight(dropdown) {
        let inner_height = window.innerHeight,
            inner_width = window.innerWidth;

        if (inner_width < 980) return;

        let headerSectionHeight = document.querySelectorAll(
                ".shopify-section-group-header-group"
            ),
            sum = 0;

        headerSectionHeight?.forEach((el) => {
            if (el.id.indexOf("_header") > 0) sum += el.offsetHeight; // get all header top sections height
        });

        dropdown.forEach((item) => {
            let innerHeightWithNoHeaderHeight = inner_height - sum;
            // fix for Firefox and Safari browsers
            // set dropdown inner max height
            item.style.maxHeight = innerHeightWithNoHeaderHeight + "px";
            item.style.overflowX = "auto";
        });
    }

    highlightParentItemOnActiveChild(detail) {
        /* Highlight the first menu item permanently enabled */
        if (this.container.children[0].dataset.linkHighlighted == "true")
            return;

        let dropdownInner = detail.children[1],
            activeChild = dropdownInner.querySelector(
                ".list-menu__item--active"
            );

        if (activeChild)
            detail.parentElement.parentElement.classList.add(
                "highlite_parent_item_on_active_child"
            );
        else
            detail.parentElement.parentElement.classList.remove(
                "highlite_parent_item_on_active_child"
            );
    }

    disconnectedCallback() {
        this.overlay.removeEventListener(
            "mouseover",
            this.removeOverlay.bind(this)
        );
        this.overlay.removeEventListener(
            "click",
            this.removeOverlay.bind(this)
        );
    }
}

customElements.define("header-menu", HeaderMenu);

/* create custom event for better behavior on top level mouseover */
(function (mouseStopDelay) {
    var timeout;
    document.addEventListener("mouseover", function (e) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            var event = new CustomEvent("mousestop", {
                detail: {
                    clientX: e.clientX,
                    clientY: e.clientY,
                },
                bubbles: true,
                cancelable: true,
            });
            e.target.dispatchEvent(event);
        }, mouseStopDelay);
    });
})(150);
